<template>
  <div
    v-if="episodeData"
    :class="[{'b-b-1': hasBorder}, 'episode-card']">
    <div class="episode-card-img">
      <picture-component
        :src="episodeData.display_image_url || episodeData.image_url"/>
    </div>
    <div class="episode-content">
      <PremiumIndicator v-if="episodeData.is_exclusive" />
      <p
        class="episodeTitle"
        @click="redirect ? goToEDP() : ''">
        {{ episodeData.title || 'Title not Available' }}
      </p>
      <p class="podcastName">{{ podcastName(episodeData.season) }}</p>
      <p class="releasedAt">{{ episodeData.released_at | podcastDateFilter }}</p>
    </div>
    <div class="play-pause-btn">
      <svg v-if="playerIcon === pauseIcon" svg-inline="" class="pause-btn" @click="pauseEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 24"><defs><path id="ic_pause_blue_svg__a" d="M611.666667,209 L616.333334,209 C616.885618,209 617.333334,209.447715 617.333334,210 L617.333334,232 C617.333334,232.552285 616.885618,233 616.333334,233 L611.666667,233 C611.114382,233 610.666667,232.552285 610.666667,232 L610.666667,210 C610.666667,209.447715 611.114382,209 611.666667,209 Z M623.666667,209 L628.333334,209 C628.885618,209 629.333334,209.447715 629.333334,210 L629.333334,232 C629.333334,232.552285 628.885618,233 628.333334,233 L623.666667,233 C623.114382,233 622.666667,232.552285 622.666667,232 L622.666667,210 C622.666667,209.447715 623.114382,209 623.666667,209 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-610.000000, -209.000000)"><use fill="#00AECB" xlink:href="#ic_pause_blue_svg__a"/></g></g></svg>
      <svg v-if="playerIcon === playIcon" svg-inline="" class="play-btn" @click="playEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 41 41"><defs><circle id="btn_play_base_svg__a" cx="20" cy="20" r="20"/><path id="btn_play_base_svg__b" d="M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M20,38 C29.9411255,38 38,29.9411255 38,20 C38,10.0588745 29.9411255,2 20,2 C10.0588745,2 2,10.0588745 2,20 C2,29.9411255 10.0588745,38 20,38 Z"/><path id="btn_play_base_svg__d" d="M3.05525082,17.6189112 C2.49242755,18.0414465 1.75090624,18.1185553 1.11691769,17.8204734 C0.482929132,17.5223914 0.0556453754,16.8957463 0,16.182426 L0,1.81757402 C0.0556453754,1.10425375 0.482929132,0.477608613 1.11691769,0.179526646 C1.75090624,-0.118555322 2.49242755,-0.0414464676 3.05525082,0.38108882 L13.2341707,7.5635148 C13.7113541,7.87710942 14,8.41852969 14,9 C14,9.58147031 13.7113541,10.1228906 13.2341707,10.4364852 L3.05525082,17.6189112 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g opacity="0.24"><g transform="translate(-44.000000, -587.000000) translate(44.321434, 587.849583)"><mask id="btn_play_base_svg__c" fill="white"><use xlink:href="#btn_play_base_svg__b"/></mask><g fill="#00AECB" mask="url(#btn_play_base_svg__c)"><rect width="40" height="40"/></g></g></g><g><g transform="translate(-44.000000, -587.000000) translate(44.321434, 587.849583) translate(9.000000, 8.000000) translate(5.000000, 3.000000)"><mask id="btn_play_base_svg__e" fill="white"><use xlink:href="#btn_play_base_svg__d"/></mask><g fill="#00AECB" mask="url(#btn_play_base_svg__e)"><g transform="translate(-5.000000, -3.000000)"><rect width="24" height="24"/></g></g></g></g></g></g></g></svg>
      <i
        v-if="isLoading"
        class="el-icon-loading text-blue"/>
    </div>
  </div>
</template>
<script>
import PictureComponent from './PictureComponent';
import PremiumIndicator from './PremiumIndicator';
import PremiumContentModal from './PremiumContentModal';
import SegmentEvent from '../services/PlayerEvent';
import replayIcon from '../assets/images/ic_replay_blue.svg';
import playIcon from '../assets/images/ic_play_blue.svg';
import pauseIcon from '../assets/images/ic_pause_blue.svg';

export default {
  name: 'EpisodeCard',
  components: {
    PictureComponent,
    PremiumContentModal,
    PremiumIndicator,
  },
  props: {
    episodeData: {
      type: Object,
      default: () => {},
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    redirect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      playIcon,
      pauseIcon,
      replayIcon,
      play: false,
      eventProvider: new SegmentEvent(),
    };
  },
  computed: {
    isPlaying() {
      const currentlyPlayingEpisode = this.$store.getters.episode;
      const playing = this.$store.getters.play;

      return playing && (currentlyPlayingEpisode && (currentlyPlayingEpisode.uuid === this.episodeData.uuid));
    },
    isLoading() {
      const { status, episode } = this.$store.getters;
      return status === 'loading' && episode && (episode.uuid === this.episodeData.uuid);
    },
    episodeListened() {
      if (this.shows) {
        const progress = this.$store.getters.episodeProgressByUuid(this.episodeData.uuid);
        if (progress) {
          return progress.progress_percent >= 95;
        }
        return false;
      }
      return false;
    },
    playerIcon() {
      if (this.isLoading) {
        return null;
      }
      if (this.isPlaying) {
        return this.pauseIcon;
      }
      if (this.episodeListened && !this.isPlaying) {
        return this.replayIcon;
      }
      return this.playIcon;
    },
  },
  watch: {
    play() {
      if (this.play) this.playEpisode();
      else this.pauseEpisode();
    },
  },
  methods: {
    playEpisode() {
      this.play = true;
      this.loadMediaInPlayer(this.episodeData.media_url, this.episodeData.is_exclusive);
      this.$store.dispatch('setAndPlayEpisode', this.episodeData);
      this.eventProvider.triggerEpisodePlayEvent(this.episodeData);
    },
    pauseEpisode() {
      this.play = false;
      this.$store.dispatch('pause');
      this.eventProvider.triggerEpisodePauseEvent(this.episodeData);
    },
    replayEpisode() {
      this.$store.dispatch('setProgress', 0);
      this.playEpisode();
    },
    podcastName(obj) {
      return (obj && obj.podcast && obj.podcast.title) || 'Not Available';
    },
    goToEDP() {
      this.$router.push(`/listen/${this.episodeData.season.podcast.publisher.slug}/${this.episodeData.season.podcast.slug}/${this.episodeData.slug}/${this.episodeData.uuid}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
.episode-card {
  padding: 16px 0;
  display: flex;
  align-items: center;
  max-width: 410px;
  width: 100%;
  .episode-card-img {
    img {
      width: 86px;
      height: 86px;
      border: 1px solid rgba(17,17,17,0.1);
    }
  }
  .episode-content {
    flex: 1;
    margin: 0 16px;
    position: relative;
    top: -5px;

    .episodeTitle {
      font-size: 16px;
      color: $black;
      margin: 0 0 4px 0;
      line-height: 18px;
      height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .podcastName {
      font-size: 14px;
      line-height: 18px;
      height: 18px;
      color: $gray;
      margin: 0 0 4px 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .releasedAt {
      font-size: 12px;
      color: $gray;
      margin: 0 0 4px 0;
      height: 12px;
      line-height: 14px;
    }

    .premium-indicator {
      margin-bottom: 6px;
    }
  }
  .play-pause-btn {
    min-width: 32px;
    svg {
      cursor: pointer;
      width: 32px;
      height: 32px;
      &.pause-btn {
        width: 20px;
        height: 20px;
        padding-left: 6px;
      }
    }
  }
}
@media (max-width: 1440px) {
  .episode-card {
    max-width: 380px;
  }
}
@media (max-width: 1340px) {
  .episode-card {
    max-width: 575px;
  }
}
@media (max-width: 1024px) {
  .episode-card {
    max-width: 435px;
  }
}
@media (max-width: 768px) {
  .episode-card {
    max-width: 335px;
  }
}
@media (max-width: 576px) {
  .episode-card {
    max-width: 310px;
    padding: 12px 0;
    .episode-card-img {
      img {
        width: 56px;
        height: 56px;
      }
    }
    .episode-content {
      .releasedAt {
        display: none;
      }

      top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/EpisodeCard.vue